import { useSaleFlowDesign } from '../hooks/useSaleFlowDesign';

/**
 * Headless component — renders nothing, only applies the saleflow CSS design
 * override as a side effect via a <style> tag injected into <head>.
 *
 *
 * How it works:
 *   1. On mount it calls GET /api/saleflowdesign/{saleFlowId}
 *   2. If a cssValue is returned it is injected after the main stylesheet,
 *      so it wins the CSS cascade and overrides the default design variables.
 *   3. If the endpoint returns nothing (no custom design for this saleflow)
 *      the default stylesheet is left untouched.
 *   4. On unmount the injected <style> tag is removed so the next product
 *      always starts with the clean default design.
 */

const SaleFlowDesign = ({ saleFlowId }) => {
  useSaleFlowDesign(saleFlowId);
  return null;
};

export default SaleFlowDesign;
